import {
  AEGON_QUEUE_LOAD,
  AEGON_QUEUE_UPDATE,
  AEGON_QUEUE_ERROR,
  AEGON_DOCTOR_STATE_SET,
  AEGON_CALL_STARTED,
} from '../actions/aegonQueue';

const defaultState = {
  stats: {},
  queue: [],
  doctors: [],
  doctorStatus: null,
  assignedCase: null,
  activeCall: null,
  error: null,
};

export default function aegonQueue(state = defaultState, action) {
  switch (action.type) {
    case AEGON_QUEUE_LOAD:
    case AEGON_QUEUE_UPDATE:
      return {
        ...state,
        stats: action.payload.stats || state.stats,
        queue: action.payload.queue || state.queue,
        doctors: action.payload.doctors || state.doctors,
        error: null,
      };

    case AEGON_DOCTOR_STATE_SET:
      return {
        ...state,
        doctorStatus: action.payload.doctorStatus || state.doctorStatus,
        assignedCase: action.payload.assignedCase,
        error: null,
      };

    case AEGON_CALL_STARTED:
      return {
        ...state,
        activeCall: action.payload,
        doctorStatus: { ...(state.doctorStatus || {}), status: 'IN_CALL' },
      };

    case AEGON_QUEUE_ERROR:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
